import { render, staticRenderFns } from "./TextSizeToggle.vue?vue&type=template&id=ee0c11ea"
import script from "./TextSizeToggle.vue?vue&type=script&lang=js"
export * from "./TextSizeToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports